import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Alert, Row, Col } from 'antd';
import { LockOutlined, KeyOutlined } from '@ant-design/icons';
import { IPageData, IPageProps } from '../../interfaces/page-data';
import { IAuthentication } from '../../interfaces/authentication';
import { StateLoader } from '../../redux/StateLoader';
import HTTPService from '../../utils/makerequest';
import { toast } from 'react-hot-toast';

const PageChangePassword: React.FC<IPageProps> = (props) => {
  const { onSetPage } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<{ type: 'success' | 'error'; msg: string } | null>(null);
  const [form] = Form.useForm();

  const stateLoader = new StateLoader();
  const authInfo: IAuthentication = stateLoader.getAuthState();

  const pageData: IPageData = {
    title: 'Şifre Değiştir',
    loaded: true,
    breadcrumbs: [
      { title: 'Gösterge Paneli', route: 'dashboard' },
      { title: 'Profilim', route: `/user/${authInfo?.userID}` },
      { title: 'Şifre Değiştir' },
    ],
  };

  useEffect(() => {
    onSetPage(pageData);
  }, []);

  const onFinish = async (values: any) => {
    setLoading(true);
    setStatus(null);

    try {
      const response = await HTTPService.PUT('/user/changePassword', {
        userId: authInfo?.userID,
        oldPassword: values.oldPassword,
        password: values.newPassword,
      });

      if (response.status === 200 || response.status === 201) {
        const succMsg = response.data?.message || 'Şifreniz başarıyla değiştirildi. Giriş sayfasına yönlendiriliyorsunuz...';
        setStatus({ type: 'success', msg: succMsg });
        toast.success(succMsg);
        form.resetFields();

        setTimeout(() => {
          stateLoader.removeAuthState();
          window.location.replace('/public/sign-in');
        }, 1500);
      } else {
        const errMsg = response.data?.message || response?.errorText || 'Şifre değiştirilemedi. Lütfen mevcut şifrenizi kontrol ediniz.';
        setStatus({ type: 'error', msg: errMsg });
        toast.error(errMsg);
      }
    } catch (error: any) {
      const errMsg = error?.response?.data?.message || error?.errorText || 'Şifre değiştirilirken bir hata oluştu!';
      setStatus({ type: 'error', msg: errMsg });
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ marginTop: '20px' }}>
      <Col xs={24} sm={20} md={16} lg={12} xl={10}>
        <Card
          title={
            <span>
              <KeyOutlined style={{ marginRight: '8px', color: '#3640f9' }} />
              Şifre Değiştir
            </span>
          }
          className="shadow-sm"
        >
          {status && (
            <Alert
              className="mb-4"
              message={status.msg}
              type={status.type}
              showIcon
              closable
              onClose={() => setStatus(null)}
            />
          )}

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="Eski Şifre"
              name="oldPassword"
              rules={[
                { required: true, message: 'Lütfen mevcut şifrenizi giriniz!' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Mevcut şifreniz"
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Yeni Şifre"
              name="newPassword"
              rules={[
                { required: true, message: 'Lütfen yeni şifrenizi giriniz!' },
                { min: 6, message: 'Yeni şifre en az 6 karakter olmalıdır!' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Yeni şifreniz"
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Yeni Şifre (Tekrar)"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Lütfen yeni şifrenizi tekrar giriniz!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Girdiğiniz yeni şifreler eşleşmiyor!'));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Yeni şifrenizi doğrulayın"
                size="large"
              />
            </Form.Item>

            <Form.Item className="mt-4 mb-0 text-right">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                style={{ borderRadius: '6px' }}
              >
                Şifreyi Güncelle
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default PageChangePassword;
